import { useMemo } from 'react';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import errorI18n from '#config/error.i18n.yml';

import type { HttpError } from '#src/shared/error';

import { useLocale } from '#src/app/shared/hooks/l10n';

const FALLBACK_LOCALE = 'en-US';

type ErrorTextType = {
	header: string;
	main: string;
	back_to_home?: string;
};

export function useErrorText(code: HttpError['code'] | 500): ErrorTextType {
	const locale = useLocale();
	const { i18n } = useUtilityContext();

	return useMemo(() => {
		// not using normal translation file as retrieving that file could actually be the cause of this error
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		const errorTranslations = errorI18n[locale] || errorI18n[FALLBACK_LOCALE]!;

		if (typeof code !== 'number') {
			return {
				header: i18n.translationExists(`corgi.error.${code}.header`)
					? i18n.translate(`corgi.error.${code}.header`)
					: i18n.translate('corgi.error.fallback.header'),
				main: i18n.translationExists(`corgi.error.${code}.main`)
					? i18n.translate(`corgi.error.${code}.main`)
					: i18n.translate('corgi.error.fallback.main'),
				// TODO: update this with i18n.translate('corgi.error.fallback.back_to_home') when the translations are added
				// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
				back_to_home: errorTranslations ? errorTranslations.back_to_home : undefined,
			};
		}

		return { ...errorTranslations[code === 401 ? 403 : code], back_to_home: errorTranslations.back_to_home };
	}, [i18n, code, locale]);
}
